const extract_user = (email) => {
  return email.replace('@uach.mx', "")
}

export default extract_user;



// WEBPACK FOOTER //
// ./src/functions/extract.js